import React, { Component } from 'react';
import './Input.css';

class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.defaultChecked || this.props.checked || false,
      required: ''
    };
  }

  handleChange = (event) => {
    if (this.props.handleCheckboxChange) {
      const { handleCheckboxChange, label, id } = this.props;
      handleCheckboxChange(label, id);
    }
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }

  render() {
    const {
      id: idInput = '0',
      required: requiredInput = false,
      disabled: disabledInput = false
    } = this.props;

    return (
      <div className={`input ${this.props.modifier ? this.props.modifier : ''}`}>
        <input
          className="input__checkbox"
          type="checkbox"
          defaultChecked={this.state.isChecked}
          id={idInput}
          onChange={this.handleChange}
          required={requiredInput}
          disabled={disabledInput}
        />
        {
          this.props.children ?
          <label className="input__label" htmlFor={idInput}>{this.props.children}</label>
          :
          <label className="input__label" htmlFor={idInput} dangerouslySetInnerHTML={{ __html: this.props.label }} />
        }
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Input/Checkbox.js